import { cloneDeep } from 'lodash';
import { alarmListMode, dashboardCustomizeConstants } from './constants';

const spacingProperties = {
  spacingTop: 0,
  spacingRight: 0,
  spacingBottom: 0,
  spacingLeft: 0,
};
function getExtraProperties(widgetTypeName) {
  switch (widgetTypeName) {
    case dashboardCustomizeConstants.widget1:
      return {
        ...spacingProperties,
        mode: alarmListMode[0].id,
        filteredByGroup: null,
      };
    case dashboardCustomizeConstants.widget4:
      return {
        ...spacingProperties,
        alarms: [],
        numberOfColumns: 1,
      };
    default:
      return { ...spacingProperties };
  }
}
export function convertToStandard(resp) {
  resp.map((_resp) => {
    if (_resp['width'] === -1 || _resp['width'] === '-1') {
      _resp['width'] = '';
    }
    if (_resp.extraProperties.hasOwnProperty('alarms')) {
      if (_resp.extraProperties.alarms) {
        _resp.extraProperties.alarms = JSON.parse(_resp.extraProperties.alarms);
      } else _resp.extraProperties.alarms = [];
    }
  });
  return resp;
}
export function initWidgets(widgetTypes) {
  const result = [];
  widgetTypes.forEach((widgetType, index) => {
    result.push({
      widgetTypeId: widgetType.id,
      widgetTypeName: widgetType.name,
      x: 0,
      y: 0,
      width: '',
      height: -1,
      title: 'Title',
      description: 'description',
      index,
      extraProperties: getExtraProperties(widgetType.name),
      terminateRow: false,
    });
  });
  return result;
}

export function getAvailableWidgets(usingWidgets, widgetTypes) {
  let _widgetTypes = cloneDeep(widgetTypes);
  const usingWidgetsIds = usingWidgets.map(
    (usingWidget) => usingWidget.widgetTypeId,
  );
  const result = _widgetTypes.filter(
    (widgetType) => !usingWidgetsIds.includes(widgetType.id),
  );
  return result;
}

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const getItemStyle = (isDragging, draggableStyle, isLast) => ({
  display: 'flex',
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  //   paddingLeft: grid * 4,
  //   margin: `0 0 ${grid}px 0`,
  // change background colour if dragging
  // background: 'transparent',
  // marginBottom: isLast ? 0 : 5,
  // styles we need to apply on draggables
  ...draggableStyle,
});

export const getDragIconStyle = (isDragging) => ({
  userSelect: 'none',
  background: isDragging ? 'lightgreen' : '#EFEFEF',
  color: 'black',
  fontWeight: 600,
});

export function getSharedDefaultStyles() {
  return {
    height: 'fit-content',
  };
}
export function getSpacingAround(top, right, bottom, left) {
  const _left = left ? parseInt(left) : 0;
  const _right = right ? parseInt(right) : 0;
  const _top = top ? parseInt(top) : 0;
  const _bottom = bottom ? parseInt(bottom) : 0;
  return { padding: `${_top}px ${_right}px ${_bottom}px ${_left}px` };
}
